import { render, staticRenderFns } from "./roleAccess.vue?vue&type=template&id=ca5bd748&scoped=true"
import script from "./roleAccess.vue?vue&type=script&lang=js"
export * from "./roleAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5bd748",
  null
  
)

export default component.exports